export const DISMISSABLE_WARNINGS = {
  EMPLOYEE_MISSION_VALIDATION: "employee-validation",
  ADMIN_MISSION_MODIFICATION: "admin-mission-modification",
  EMPLOYEE_GEOLOCATION_INFORMATION: "employee-geolocation-information",
  EMPLOYEE_OFF_CREATION: "employee-off-creation"
};
